import { render, staticRenderFns } from "./BusinessesList.vue?vue&type=template&id=4e82d36d&scoped=true"
import script from "./BusinessesList.vue?vue&type=script&lang=js"
export * from "./BusinessesList.vue?vue&type=script&lang=js"
import style0 from "./BusinessesList.vue?vue&type=style&index=0&id=4e82d36d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e82d36d",
  null
  
)

export default component.exports